import { Box, Row, Title } from '@factorialco/deprecated-design-system'

import WorkingConditionItem from 'modules/contracts_settings/components/WorkConditions/WorkingConditionItem'
import {
  WorkingConditionVersionSectionProps,
  getI18nSectionKey,
} from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'

const WorkingConditionsVersionDetailsSection = (section: WorkingConditionVersionSectionProps) => {
  const sectionTitle = getI18nSectionKey(section.label, 'title')
  const sectionDescription = getI18nSectionKey(section.label, 'description')
  const workingConditionItems = (
    <Box gap="s16">
      {section.items.map((item) => (
        <WorkingConditionItem key={item.name} {...item} />
      ))}
    </Box>
  )

  return (
    <Box padding="s24" gap="s32" width="full">
      <Row key={section.label}>
        <Row.Col halfWidth>
          <Box padding="s24" gap="s16">
            <Title
              variant="500"
              illustration={section.icon}
              title={sectionTitle}
              description={sectionDescription}
            />
          </Box>
        </Row.Col>
        <Row.Col halfWidth>
          {section.group_items ? (
            <Box background="grey200" borderRadius={{ all: 'abs016' }} padding="s24" gap="s16">
              {workingConditionItems}
            </Box>
          ) : (
            workingConditionItems
          )}
        </Row.Col>
      </Row>
    </Box>
  )
}

export default WorkingConditionsVersionDetailsSection
